import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-2 lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-compass-3-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50">九色导航</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-sm">
              专业的一站式网址导航平台，汇聚海量优质网站资源。
              让上网更简单、更高效，是您每天必备的浏览器导航首页。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/articles" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  文章中心
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  网站收录
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  友情链接
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-foreground-400 flex items-center gap-2">
                <i className="ri-mail-line text-sm"></i>
                <span>contact@jiusenavigation.com</span>
              </li>
              <li className="text-sm text-foreground-400 flex items-center gap-2">
                <i className="ri-customer-service-2-line text-sm"></i>
                <span>在线客服</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 九色导航 JiuSeDaoHang. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}